import React from 'react';
import TimelineItem from './TimelineItem';
import './ContentSection.css';

function ContentSection({ scheduleItems, sectionTitle = 'Schedule of Events' }) {
  return (
    <div className="content-section">
      <h2 className="section-title">{sectionTitle}</h2>
      <div className="timeline">
        {scheduleItems.map((item, index) => (
          <TimelineItem 
            key={index}
            time={item.time}
            event={item.event}
          />
        ))}
      </div>
    </div>
  );
}

export default ContentSection; 